/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchScenarioChatsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchScenarioChatsQuery = { scenarioChats: { scenarioChats: Array<{ guid: string, title: string }> } };

export type FetchInflowSourceConditionQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchInflowSourceConditionQuery = { segmentConditionParameters: { inflowSourceCondition: { inflowSources: Array<{ guid: string, inflowSourceName: string }> } } };


export const FetchScenarioChatsDocument = gql`
    query FetchScenarioChats {
  scenarioChats {
    scenarioChats {
      guid
      title
    }
  }
}
    `;

/**
 * __useFetchScenarioChatsQuery__
 *
 * To run a query within a Vue component, call `useFetchScenarioChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchScenarioChatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchScenarioChatsQuery();
 */
export function useFetchScenarioChatsQuery(options: VueApolloComposable.UseQueryOptions<FetchScenarioChatsQuery, FetchScenarioChatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchScenarioChatsQuery, FetchScenarioChatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchScenarioChatsQuery, FetchScenarioChatsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchScenarioChatsQuery, FetchScenarioChatsQueryVariables>(FetchScenarioChatsDocument, {}, options);
}
export function useFetchScenarioChatsLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchScenarioChatsQuery, FetchScenarioChatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchScenarioChatsQuery, FetchScenarioChatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchScenarioChatsQuery, FetchScenarioChatsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchScenarioChatsQuery, FetchScenarioChatsQueryVariables>(FetchScenarioChatsDocument, {}, options);
}
export type FetchScenarioChatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchScenarioChatsQuery, FetchScenarioChatsQueryVariables>;
export const FetchInflowSourceConditionDocument = gql`
    query FetchInflowSourceCondition {
  segmentConditionParameters {
    inflowSourceCondition {
      inflowSources {
        guid
        inflowSourceName
      }
    }
  }
}
    `;

/**
 * __useFetchInflowSourceConditionQuery__
 *
 * To run a query within a Vue component, call `useFetchInflowSourceConditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchInflowSourceConditionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchInflowSourceConditionQuery();
 */
export function useFetchInflowSourceConditionQuery(options: VueApolloComposable.UseQueryOptions<FetchInflowSourceConditionQuery, FetchInflowSourceConditionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchInflowSourceConditionQuery, FetchInflowSourceConditionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchInflowSourceConditionQuery, FetchInflowSourceConditionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchInflowSourceConditionQuery, FetchInflowSourceConditionQueryVariables>(FetchInflowSourceConditionDocument, {}, options);
}
export function useFetchInflowSourceConditionLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchInflowSourceConditionQuery, FetchInflowSourceConditionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchInflowSourceConditionQuery, FetchInflowSourceConditionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchInflowSourceConditionQuery, FetchInflowSourceConditionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchInflowSourceConditionQuery, FetchInflowSourceConditionQueryVariables>(FetchInflowSourceConditionDocument, {}, options);
}
export type FetchInflowSourceConditionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchInflowSourceConditionQuery, FetchInflowSourceConditionQueryVariables>;